import * as React from 'react';
import { SVGProps } from 'react';

const MockExamBackground = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 800 800"
    {...props}
  >
    <defs></defs>
    <path
      style={{ fill: '#5fa7d4' }}
      d="m570.24,281.07l-421.46,141.68c-51.73,17.39-86.57,65.86-86.57,120.44v256.49h675.58v-398.17c0-86.86-85.21-148.11-167.54-120.44Z"
    />
    <path
      style={{ fill: '#80bce0' }}
      d="m737.79,400.24h0v399.43h-399.43c0-220.45,178.98-399.43,399.43-399.43Z"
    />
    <circle style={{ fill: '#80bce0' }} cx="202.48" cy="413.41" r="98.81" />
  </svg>
);

export default MockExamBackground;
